import { Button, Flex, Text } from "@chakra-ui/react";
import Header from "../../components/Header";
import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <>
      <Flex
        w="full"
        h="calc(100vh - 6.5rem)"
        alignItems="center"
        justifyContent="flex-start"
        flexDir="column"
      >
        <Text
          as="h1"
          textAlign="center"
          fontSize="10rem"
          color="gray.600"
          transform="rotate(90deg)"
        >
          :(
        </Text>
        <Text as="h1" textAlign="center" fontSize="3rem" color="gray.600">
          Ooops!! Página não encontrada!
        </Text>

        <Button variant="ghost" colorScheme="blue" size="md" as={Link} to="/">
          Voltar para a página inicial
        </Button>
      </Flex>
    </>
  );
}
